import React, { useState, useContext } from 'react';
import { Alert, Modal, Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import { Button, ButtonToolbar, ButtonGroup } from '@/shared/components/Button';
import { GlobalVarContext } from '../../../../../context/GlobalVarContext';
import ConfirmationModal from '../ConfirmationModal';
import { PermissionContext } from '../../../../../context/PermissionContext';
import RejectReasonForm from './RejectReasonForm';
import ShowPaxtable from './ShowPaxtable';
import { AuthContext } from '../../../../../context/AuthContext';



const PendingCard = ({
 bookingData, setRefresh, 
}) => {
       const [confirmBokingModal, setConfirmBookingModal] = useState(false);
       const [bookingID, setBookinigID] = useState();
       const [Paxs, setPax] = useState([]);
       const [showPaxmodal, setShowPaxmodal] = useState(false);
       const { apiGlobal } = useContext(GlobalVarContext);
       const { permissionsAccess } = useContext(PermissionContext);
       const [showRejectBookingModal, setShowRejectBookingModal] = useState(false);
       const { userid, currencyCode, countryId } = useContext(AuthContext);


      
   const formatDate = (dateString) => {
    if (!dateString) return ''; // Handle empty values
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };

  const openConfirmmodal = (id) => {
    setBookinigID(id);
    setConfirmBookingModal(true);
  };

  const handleConfirmBooking = async () => {
    const formdata = new FormData();
    formdata.append('id', bookingID);
    formdata.append('isApproved', 2);
    formdata.append('type', 2);
    formdata.append('user_id', userid);
    formdata.append('country_id', countryId);
    try {
      const url = await fetch(`${apiGlobal}/agent/booking_confirmation.php`, {
        method: 'POST',
        body: formdata,
      });
      console.log(url);
      const response = await url.json();
      console.log(response);
      if (response?.status && response?.message === 'Success') {
        toast.success('Waiting for payment');
        setConfirmBookingModal(false);
        setRefresh(prev => !prev);
      } else {
        toast.error('Error in confirming booking');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const showPaxDetailsModal = (paxDetails) => {
    setShowPaxmodal(true);
    setPax(paxDetails);
  };

 
  const openRejectbookingmodal = (id) => {
    console.log('x');
    setBookinigID(id);
    setShowRejectBookingModal(true);
  };

  const handleRejectBooking = async (value) => {
    const formdata = new FormData();
    formdata.append('id', bookingID);
    formdata.append('isApproved', 5);
    formdata.append('type', 2);
    formdata.append('user_id', userid);
    formdata.append('reason', value?.reason);
    formdata.append('country_id', countryId);
 
    try {
      const url = await fetch(`${apiGlobal}/agent/booking_confirmation.php`, {
        method: 'POST',
        body: formdata,
      });
      // console.log(url);
      const response = await url.json();
      // console.log(response);
      if (response.status && response.message === 'Success') {
        toast.success('Booking Rejected Successfully');
        setShowRejectBookingModal(false);
        setBookinigID();
        setRefresh(prev => !prev);
      } else {
        toast.error('Error in confirming booking');
      }
    } catch (error) {
      console.error(error);
    }
  };


  return (

    <div>
      {!bookingData ? (
        <div>Booking Data Not Passed</div> // Show message if no bookingData
      ) : (
        <div className="card mb-4 shadow-sm" style={{ maxWidth: '100%', borderColor: 'black' }}>
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-12">
                {/* <h5 className="fw-bold">{bookingData.name}</h5> */}
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-md-4" style={{ display: 'flex' }}>
                <h4 className="fw-bold d-flex">Trip:<p className="">{bookingData?.name}-{bookingData?.trip_uin}</p></h4>
              </div>
              <div className="col-md-4" style={{ display: 'flex' }}>
                <p className="mb-1">
                  <strong>Start Date:</strong> {bookingData?.start_date ? formatDate(bookingData?.start_date) : ''}
                </p>
                <p style={{ marginLeft: '12px' }}>
                  <strong>End Date:</strong>{bookingData?.end_date ? formatDate(bookingData?.end_date) : ''}
                </p>
              </div>

              <div className="col-md-4 text-end">
                {/*             
                <Button 
                  variant="outline-warning" 
                  size="sm" 
                  className="mx-1" 
                  title="Edit trip"
                >
                  Edit Trip
                </Button> */}
                {/* <Button 
                  onClick={() => addMealHandler(bookingData.id, bookingData.name)} 
                  variant="outline-primary" 
                  size="sm" 
                  className="mx-1" 
                  title="Add Meal"
                >
                  Add Meal
                </Button> */}
              </div>
            </div>

            {bookingData?.booking_details 
  && [...bookingData.booking_details]
    .sort((a, b) => (a.status === '0' ? -1 : 1)) // Sort meals with status '0' first
    .map((meal, index) => (
      <div className="card mb-4 shadow-sm" key={meal?.id} style={{ maxWidth: '100%' }}>
        <div className="card-body">
          {/* Meal Day Header with Actions */}
          <div className="row mb-2 align-items-center" style={{ display: 'flex' }}>
            <div className="col-md-8 d-flex align-items-center">
              <h6 className="me-2">
                {meal?.day_name} - {meal?.booking_date ? formatDate(meal?.booking_date) : ''}
                {' '} 
                <span className={String(meal?.status) === '0' ? 'text-danger' : 'text-warning'}>
                  {/* ({String(meal.status) === '1' ? 'Awaiting Approval' : 'Awaiting Payment'}) */}
                </span>
              </h6>
            
              <Button 
                variant="outline-primary" 
                size="sm" 
                className="mx-2 mt-3 flex " 
                title=" View Paxs"
                onClick={() => showPaxDetailsModal(meal?.trip_pax_details)}
              >
                Paxs
              </Button>
              {permissionsAccess?.[2]?.master_id === '3'
  && permissionsAccess?.[2]?.approval === 1
  && String(meal?.status) === '1' && (
    <div>
      <Button 
        variant="outline-success"
        size="sm"
        className="mx-2 mt-3"
        title="Approve"
        onClick={meal?.id ? () => openConfirmmodal(meal.id) : undefined}
        disabled={!meal?.id}
      >
        Approve
      </Button>
      <Button
        variant="outline-danger"
        size="sm"
        className="mx-2 mt-3"
        title="Reject"
        onClick={meal?.id ? () => openRejectbookingmodal(meal?.id) : undefined}
        disabled={!meal?.id}
      >
        Reject
      </Button>
    </div>
    
)}

             
            </div>
          </div>
          {/* Meal Details */}
          <div className="row border p-3 rounded">
            <div className="col-md-3">
              <p><strong>{meal?.meal_name}/{meal?.restaurant_name}</strong></p>
              <p className="text-muted">Locations: {meal?.location}</p>
            </div>
            <div className="col-md-3">
              <p>
                <strong>Timing:</strong> 
                {{
                  1: 'Breakfast',
                  2: 'Snacks',
                  3: 'Lunch',
                  4: 'Dinner',
                }[meal?.meal_offered] || 'Unknown'}
              </p>
              <p><strong>Total Meals:</strong> {meal?.total_meal}</p>
            </div>
            <div className="col-md-3">
              <p><strong>Type:</strong>   {{
                  1: 'Fit',
                  2: 'Git',
                  3: 'Delivery',
                  // 4: 'Dinner',
                }[meal?.meal_format] || 'Unknown'}
              </p>
              <p><strong>Format:</strong> {meal?.meal_type}</p>
            </div>
            <div className="col-md-3">
              <p><strong>Amount:</strong> AED {meal?.total_amount}</p>
              {/* <p><strong>Amount:</strong> {currencyCode} {meal?.total_amount}</p> */}
              <p>
                <strong>Status: </strong> 
                <span className="text-warning">
                  {/* eslint-disable-next-line */}
                  {meal?.status === '1' 
                  ? 'Awaiting approval from restaurant' 
                  : meal?.status === '2' 
                  ? 'Payment Pending' : <span style={{ color: 'red' }}>Awaiting approval from Agent</span>}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    ))}
          </div> 
          <ConfirmationModal 
            show={confirmBokingModal}
            handleClose={() => setConfirmBookingModal(false)}
            handleDelete={handleConfirmBooking}
            header="Confirm Booking"
            message="Are you sure you want to confirm this Booking?"
            buttonType="success"
            buttonText="Confirm"
          />
          <Modal
            show={showPaxmodal}
            onHide={() => setShowPaxmodal(false)}
            centered
            size="xl"
            backdrop="static" // Prevent clicking outside the modal to close it
            keyboard={false} 
            style={{
            display: 'none',
          }}
          >
            <Modal.Header closeButton>
              <Modal.Title>Pax Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ShowPaxtable paxDetails={Paxs} />
            </Modal.Body>
          </Modal>
          <Modal
            show={showRejectBookingModal}
            onHide={() => setShowRejectBookingModal(false)}
            size="md"
          >
            <Modal.Header
              closeButton
            >
              <Modal.Title>Add Reject Remark</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <RejectReasonForm onSubmit={handleRejectBooking} text="Booking" />
            </Modal.Body>
          </Modal>
        </div>

    
)}
      
 
    </div>
  );
}; 

PendingCard.propTypes = {
  bookingData: PropTypes.shape({
    id: PropTypes.string.isRequired, 
    agent_id: PropTypes.string.isRequired, 
    name: PropTypes.string.isRequired, 
    trip_uin: PropTypes.string.isRequired,
    start_date: PropTypes.string.isRequired,
    end_date: PropTypes.string.isRequired,
    booking_details: PropTypes.arrayOf(PropTypes.shape({


    })).isRequired,
  }).isRequired, 
 
  setRefresh: PropTypes.func.isRequired,
};



export default PendingCard;
